import { FeatureSettings } from "./FeatureSettings";

export const featureSettingsResolver = [FeatureSettings.serviceName, (featureSettings) => featureSettings.load()];
